import useAuth from 'app/hooks/useAuth';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

const AuthGuard = ({ children }) => {
  const { pathname } = useLocation();

  let { isAuthenticated, user } = useSelector((store) => {
    return store.auth;
  });
  if (isAuthenticated) return <>{children}</>;

  return <Navigate replace to="/session/signin" state={{ from: pathname }} />;
};

export default AuthGuard;
